<template>
    <v-form v-model="is_valid"
            :disabled="loading">
        <v-container class="base container-fluid">
            <v-row justify="center">
                <v-col>
                    <v-slide-y-transition appear>
                        <template v-slot:heading="">
                            <div class="text-center">
                                <h1 class="display-2 font-weight-bold mb-2">
                                    Validação de login
                                </h1>
                            </div>
                        </template>

                        <v-card-text class="text-center card">
                            <v-card-title class="justify-center title-card">
                                <h2>Validação de login</h2>
                            </v-card-title>

                            <v-row>
                                <v-col>
                                    <p>Seu login está protegido por aplicativo de autenticação.</p>
                                    <p>Preencha o código de verificação fornecido pelo aplicativo para continuar.</p>
                                    <p>Para usar código de recuperação certifque-se de marcar a opção relacionada.</p>
                                </v-col>
                            </v-row>
                            <v-row class="flex-column">
                                <v-col>
                                    <v-text-field v-model.trim="code"
                                                  placeholder="Código de verificação"
                                                  label="Código de verificação"
                                                  :rules="[(v) => !!v || 'Código obrigatório']"
                                                  color="secondary"
                                                  :messages="message"
                                                  required
                                                  outlined
                                                  rounded></v-text-field>
                                    <v-checkbox v-model="is_recovery"
                                                label="Usar como código de recuperação"></v-checkbox>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-btn :disabled="!is_valid"
                                           :loading="loading"
                                           color="success"
                                           @click="confirm"
                                           class="btn-ctrl btn-login"
                                           large
                                           rounded>Confirmar</v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-btn :loading="loading"
                                           color="cancel"
                                           @click="goBack"
                                           class="btn-ctrl btn-cancel"
                                           large
                                           rounded>Cancelar</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-slide-y-transition>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<style lang="css" scoped>
.card {
  padding: 1.5rem 1.5rem 1.5rem !important;
  width: 500px;
  margin: auto;
}
.title-card {
  font-size: 0.8rem;
  margin: 0 0 1rem 0;
  padding-top: 0 !important;
}
.title-card > h2 {
  font-weight: 500 !important;
}
.btn-ctrl {
  margin-top: 0 !important;
  width: 100%;
  padding: 1.7rem 0 !important;
}
.btn-login {
  background-color: var(--principal-azul) !important;
}
.btn-cancel {
  background-color: var(--warning) !important;
}
</style>

<script lang="js">
import VueRouter from 'vue-router';
import api from '@/services/AdminService';

const {
  isNavigationFailure,
  NavigationFailureType
} = VueRouter;

export default {
    data                () {
        return          {
            api,
            loading     : false,
            is_valid    : false,

            code        : '',
            message     : '',
            is_recovery : false,
            return_url  : ''
        };
    },
    methods             : {
        async confirm   () {
            try {
                this.loading = true;
                const resp      = await this.api.mfaValidateCode(
                        this.code,
                        false,
                        false,
                        this.is_recovery);
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada na confirmação.');
                    return;
                }
                this.$toast.info(resp.message || 'Confirmado!');
                setTimeout(() => this.$router.push("/home"), 750);
            } finally {
                this.loading = false;
            }
        },
        async goBack          () {
            this.loading = true;
            try {
                const resp = await this.api.doLogout(this.$router);
                if (resp.reason) {
                    this.$toast.error(resp.message || 'Falha não identificada ao limpar sessão.');
                    return;
                }
                this.$router.push({ path: "/auth" }).catch((failure) => {
                        if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
                            return Promise.resolve();
                        }
                        return Promise.reject(failure);
                    });
            } catch (e) {
                this.$toast.error(e.message || 'Falha não identificada ao limpar sessão');
            } finally {
                this.loading = false;
            }
        }
    },
    mounted             () {
        this.return_url = decodeURIComponent(this.$route.query['return_url'] || '');
    }
}
</script>